import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=0f94900b&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=0f94900b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94900b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f94900b')) {
      api.createRecord('0f94900b', component.options)
    } else {
      api.reload('0f94900b', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=0f94900b&scoped=true&", function () {
      api.rerender('0f94900b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21vwooRuNf4EY/JS/comp/GuestBox.vue"
export default component.exports